/**
 * Unit-of-Measure Labels
 *
 * One map for the whole catalogue. Three pages (browse, detail, comparison)
 * each carried their own copy listing the seven pre-plan-003 units, so the
 * thirteen units plan 003 added rendered as raw enum tokens -- a price read
 * "Rs 1,250 / running_ft". Copies drift the moment the enum grows, so there is
 * exactly one now and every page imports it.
 *
 * Kept in step with `uomEnum` in `apps/backend/src/db/schema.ts`. Anything the
 * backend can store must have an entry here; `formatUom` falls back to the raw
 * token so a newly added unit degrades to ugly rather than blank, but that
 * fallback is a bug indicator, not a feature.
 *
 * Labels follow Indian trade convention rather than SI: a site quotes "cu ft"
 * of sand and "Nos" of switches, never "cubic feet" or "pieces".
 */

export const UOM_LABELS: Record<string, string> = {
	// --- pre-plan-003 ---
	sq_ft: "sq ft",
	liter: "ltr",
	piece: "pc",
	set: "set",
	running_ft: "rft",
	kg: "kg",
	meter: "m",
	// --- plan 003 additions ---
	bag: "Bag",
	box: "Box",
	roll: "Roll",
	bundle: "Bundle",
	sq_m: "sq m",
	cft: "cu ft",
	ton: "Ton",
	quintal: "Qtl",
	pair: "Pair",
	dozen: "Dozen",
	// The most common unit token in the imported brand lists.
	nos: "Nos",
	lot: "Lot",
	// Labour lines are quoted per job, not per unit of anything.
	job: "Job",
};

/**
 * Every UOM the backend can store, in the order they are declared.
 *
 * Derived from `UOM_LABELS` rather than restated, so a unit added to the map
 * appears in every dropdown without a second edit — the drift this file exists
 * to prevent applies to the option list as much as to the labels.
 */
export const UOM_VALUES: string[] = Object.keys(UOM_LABELS);

/**
 * The display label for a stored UOM token, falling back to the token itself.
 */
export function formatUom(uom: string): string {
	return UOM_LABELS[uom] ?? uom;
}
